<ng-container *transloco="let t">

  <div>
    <div class="mat-dialog-header mat-typography">
      <h2 mat-dialog-title>{{(article$ | async)?.pageTitle}}</h2>
      <button class="mat-dialog-close-button mat-small" color="secondary" mat-icon-button (click)="close()">
        <raf-icon icon="close" size="16px"></raf-icon>
      </button>
    </div>

    <mat-dialog-content class="mat-typography">

      <raf-loading *ngIf="loading$ | async; else content" variant="inline"></raf-loading>

      <ng-template #content>
        <raf-section variant="light">
          <raf-article-content [article]="article$ | async"></raf-article-content>
        </raf-section>
      </ng-template>

    </mat-dialog-content>

    <!-- BUTTONS  -->
    <mat-dialog-actions align="center">

      <button class="mat-button-large" type="button" mat-flat-button color="primary" (click)="close()">
        {{ t('GLOBAL.CLOSE') }}
      </button>

    </mat-dialog-actions>
  </div>

</ng-container>



